import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Line,
  Polyline,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Line, { x1: "17", x2: "7", y1: "7", y2: "17", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Polyline, { points: "17 17 7 17 7 7", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "ArrowDownLeft";
const ArrowDownLeft = memo(themed(Icon));
export {
  ArrowDownLeft
};
//# sourceMappingURL=arrow-down-left.js.map
